// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 943 ? "partners" : chunkId) + "-legacy." + {"35":"fb05bfa9","76":"87b4a3ff","120":"3d3c1ed2","129":"356d2955","175":"bdf7d84d","312":"18803884","642":"1b9739ef","811":"ea1b24e8","830":"744736fa","856":"f4bc83ed","860":"c84d2d9c","894":"6742b11e","943":"c4ffec5d"}[chunkId] + ".js";
};